import Image from 'next/image';
import type { ImageIconProps } from './types';

export const IconMail = ({ width, height, className }: ImageIconProps) => {
  return (
    <Image
      src='/images/ui/icons/mail.svg'
      width={width}
      height={height}
      alt='Mail'
      className={className}
    />
  );
};
